import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { usePomodoroStore } from '@stores'
import { formatDigit } from '@utils'

const ROUTE_TITLES = {
  '/': 'Pomodoro | To Focus',
  '/tarefas': 'Lista de Tarefas | To Focus',
  '/matriz': 'Matriz de Eisenhower | To Focus',
  '/relatorio': 'Relatório de Produtividade | To Focus',
}

const PHASE_TITLES = {
  FOCUS: 'Foco',
  SHORT_BREAK: 'Intervalo curto',
  LONG_BREAK: 'Intervalo longo',
}

const getRouteTitle = pathname => ROUTE_TITLES[pathname] ?? 'To Focus'

const DocumentTitleSync = () => {
  const location = useLocation()
  const { status, activePomodoro, timerState } = usePomodoroStore()

  useEffect(() => {
    if (status === 'PROGRESS' && activePomodoro?.title) {
      const hours = timerState?.hours ?? 0
      const minutes = timerState?.minutes ?? 0
      const seconds = timerState?.seconds ?? 0
      const phaseTitle = PHASE_TITLES[activePomodoro.title] ?? activePomodoro.title
      const timeLabel = hours
        ? `${formatDigit(hours)}:${formatDigit(minutes)}:${formatDigit(seconds)}`
        : `${formatDigit(minutes)}:${formatDigit(seconds)}`

      document.title = `${timeLabel} · ${phaseTitle} | To Focus`
      return
    }

    document.title = getRouteTitle(location.pathname)
  }, [
    activePomodoro?.title,
    location.pathname,
    status,
    timerState?.hours,
    timerState?.minutes,
    timerState?.seconds,
  ])

  return null
}

export { DocumentTitleSync }
